import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "agent-yearly-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./AgentSeasonalReport.html",
})
export class AgentSeasonalReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  dataList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter = {
    season_id: 0,
    fin_id: 3,
  };
  exceldata: any;
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "agent",
    orderDir: "asc",
  };
  finyearList: any[];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("finyear") finyear;

  seasonCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  gridOptions: any;
  filterExpand = false;
  filterData: any = {
    name: "",
    //company_id: 0
  };
  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private combo: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService
  ) {}

  printConfig: any = {
    title: "Agent Seasonal report",
    columns: [],
    rows: [],
  };

  ngOnInit(): void {
    //     this.loadSeasonList();
    this.LoadFinYearList();

    this.columns = [];
    this.columns = [
      {
        name: "S.No",
        width: "100px",
        maxWidth: "100px",
        minWidth: "100px",
        prop: "sno",
        type: "sno",
      },
      {
        name: "Name",
        width: 300,
        maxWidth: 300,
        minWidth: 300,
        prop: "agent_name",
      },
      {
        name: "Summer & Ramzan Target",
        width: "100px",
        cellClass: "txtRight season1cell",
        maxWidth: "100px",
        minWidth: "100px",
        summary: "sum",
        prop: "season_3_target",
      },
      {
        name: "Summer & Ramzan Qty",
        width: "100px",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight season1cell",
        minWidth: "100px",
        prop: "season_3_qty",
      },
      {
        name: "Summer & Ramzan Diff",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight season1cell",
        minWidth: "100px",
        width: "100px",
        prop: "season_3_diff",
      },
      {
        name: "Deepavali Target",
        width: "100px",
        cellClass: "txtRight",
        maxWidth: "100px",
        minWidth: "100px",
        summary: "sum",
        prop: "season_4_target",
      },
      {
        name: "Deepavali Qty",
        width: "100px",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight season4cell",
        minWidth: "100px",
        prop: "season_4_qty",
      },
      {
        name: "Deepavali Diff",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight season4cell",
        minWidth: "100px",
        width: "100px",
        prop: "season_4_diff",
      },
      {
        name: "Aadi Target",
        width: "100px",
        cellClass: "txtRight season7cell",
        maxWidth: "100px",
        minWidth: "100px",
        summary: "sum",
        prop: "season_7_target",
      },
      {
        name: "Aadi Qty",
        width: "100px",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight season7cell",
        minWidth: "100px",
        prop: "season_7_qty",
      },
      {
        name: "Aadi Diff",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight season7cell",
        minWidth: "100px",
        width: "100px",
        prop: "season_7_diff",
      },
      {
        name: "Pongal Target",
        width: "100px",
        cellClass: "txtRight",
        maxWidth: "100px",
        minWidth: "100px",
        summary: "sum",
        prop: "season_8_target",
      },
      {
        name: "Pongal Qty",
        width: "100px",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight",
        minWidth: "100px",
        prop: "season_8_qty",
      },
      {
        name: "Pongal Diff",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight",
        minWidth: "100px",
        width: "100px",
        prop: "season_8_diff",
      },
      {
        name: "Wedding Target",
        width: "100px",
        cellClass: "txtRight",
        maxWidth: "100px",
        minWidth: "100px",
        summary: "sum",
        prop: "season_9_target",
      },
      {
        name: "Wedding Qty",
        width: "100px",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight",
        minWidth: "100px",
        prop: "season_9_qty",
      },
      {
        name: "Wedding Diff",
        summary: "sum",
        maxWidth: "100px",
        cellClass: "txtRight",
        minWidth: "100px",
        width: "100px",
        prop: "season_9_diff",
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);
    this.gridOptions = {
      columns: this.columns,
      loading: true,
    };
    // this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
    }
  }
  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }
  onOpenedFilter(): void {
    setTimeout(function () {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getAgentSeasonalReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getAgentSeasonalReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getAgentSeasonalReport();
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "applyFilter") {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      this.applyFilter();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getAgentSeasonalReport(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      season_id: this.filter.season_id,
      fin_id: this.filter.fin_id,
      // tabTitle: this.title
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getAgentSeasonalReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.columns = res.columns;

        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };
        that.exceldata = that.getData(res.columns, res.data);
        that.printConfig = {
          title: "Agent Seasonal report",
          columns: that.gridOptions.columns,
          rows: that.gridOptions.data,
        };
        that.refreshData();
        //  that.columns = res.columns;
      });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearFilter(): void {
    this.filterData = {
      name: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getAgentSeasonalReport();
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      this.filter.fin_id = id;
      return fitem["finyear"];
    }
    return "";
  }
  loadSeasonList() {
    let that = this;
    that.reportService.getNewSeasonList(this.filter).then(function (res) {
      that.seasonList = res;
    });
  }

  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      let fin = res.data[0];
      that.filterData.fin_id = fin["fin_id"];
      that.filter.fin_id = fin["fin_id"];
      that.finyearCtrl.setValue(fin["fin_id"]);
      that.getAgentSeasonalReport();
    });
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    if (data.length > 0) {
      data.push(row);
      this.page.count = data.length;
    }
  }
  onRowSelected($event) {
    let data = Object.assign($event.selected[0]);
    data["fin_id"] = this.filter.fin_id;
    const tabObj = {
      action: "NewTab",
      params: {
        tabParent: "REPORTS",
        tabName: "PartySeasonalReport",
        type: "order",
        mode: "View",
        data: data,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }
  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += isNaN(dat[col.prop]) ? 0 : dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/AgentSeasonalReport/AgentSeasonalReport.ts